<template>
    <div class="d-flex justify-content-between align-items-lg-center py-1 flex-column flex-lg-row topbar"
        @click="showDropdown = false" v-if="$route.params.id === undefined">

        <b class="mb-3 mb-lg-0">
            <router-link :to="`/`" class="text-muted btn">
                {{ appName }}
            </router-link>
            <span class="badge text-bg-dark" style="font-size: 8px !important">BETA</span>
        </b>

        <div class="hstack gap-3" v-if="$storex.getters.getToken">
            <AIModelsCard v-if="$storex.getters.getToken" />
            <CreditCard v-if="$storex.getters.getToken" />


            <div class="profile">
                <div class="dropdown position-relative" @click.stop>
                    <a href="#" class="d-flex align-items-center text-dark text-decoration-none dropdown-toggle"
                        @click.prevent.stop="showDropdown = !showDropdown">
                        <div class="user-initial">
                            {{ $storex.getters.getUserData.name?.charAt(0).toUpperCase() || "U" }}
                        </div>
                        <span class="ms-2">{{ $storex.getters.getUserData.name }}</span>
                    </a>
                    <ul v-show="showDropdown" class="dropdown-menu text-small show-dropdown">
                        <li>
                            <a class="dropdown-item" href="/logout" @click="showDropdown = false">Sign out</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-else>
            <button class="btn btn-create btn-icon-text" @click="$store.commit('setShowLoginModal', true)">
                เริ่มต้นใช้งาน
                <span class="material-symbols-outlined" style="font-size: 14px;">login</span>
            </button>
        </div>
    </div>
</template>

<script>
import emitter from '../helpers/eventBus';
import CreditCard from '../components/CreditCard';
import AIModelsCard from '../components/AIModelsCard';



export default {
    name: "SidebarMenu",
    components: { AIModelsCard, CreditCard },
    computed: {
        appName() {
            return process.env.VUE_APP_NAME || 'MyApp';
        }
    },
    data() {
        return {
            showDropdown: false,

        };
    },
    mounted() {
        window.addEventListener("mousedown", this.handleClickOutside);
    },
    beforeUnmount() {
        window.removeEventListener("mousedown", this.handleClickOutside);
    },
    methods: {

        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.showDropdown = false;
            }
        },
        handleDelete() {
            emitter.emit('deleteDocument');
        },
        handleSave() {
            emitter.emit('saveDocument');
        },

    }
};
</script>

<style scoped>
.profile {
    border: 1px solid var(--gray-1);
    border-radius: 50px;
    padding: 0.2em 0.3em;
}
</style>
